import React, { useState } from "react";

import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import Constants from "../../utils/Constants";
import SplashScreen from "../../components/loader/SplashScreen/SplashScreen";
import { useEffect } from "react";
import SearchHead from "../../components/custom/SearchHead";
import ReactPaginate from "react-paginate";
import UIkit from "uikit";
import { usePermissions } from "../../context/PermissionsContext";
import { DataFormat, Edit, Play, Stop } from "@carbon/icons-react";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";



const SurveyList = () => {
  const [page, setPage] = useState(1);
  const [loader, Setloader] = useState(false);
  const [searchparam, setsearchparam] = useState(null);
  const [surveyDetails, setsurveyDetails] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const {Permissions} = usePermissions();

  // TODO: Replace this API with surveys endpoint
  const SurveysApi = (page) => {
    return axios({
      method: "get",
      params: {
        page: page || 1,
        limit: 100,
        // if search Param is null it wont be included in param 
        ...(searchparam ? { search: searchparam } : {}),
        ...(startDate ? { 'createdAt[gte]': startDate } : {}),
        ...(endDate ? { 'createdAt[lte]': endDate } : {}),
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: Constants.url + "survey-templates",
    }).then((res) => {
      return res.data.data;
    });
  };

  const {
    data: Surveysdata,
    isLoading,
    refetch,
  } = useQuery({
    queryFn: () => SurveysApi(page),
    queryKey: ["Surveysdata", page],
    staleTime: Infinity,
    cacheTime: 1000 * 60 * 60,
  });

  const Surveys = Surveysdata?.templates || [];


  useEffect(() => {
    refetch()
  } , [searchparam , startDate , endDate])

  // TODO: Update headers for survey data
  const headers = [
    { label: "S.NO", key: "" },
    { label: "Full Name", key: "fullname" },
    { label: "Email", key: "email" },
    { label: "Type", key: "type" },
    { label: "Phone", key: "phone" },
    { label: "City", key: "city" },
    { label: "Created At", key: "createdAt" },
  ];

  const Refresh = () => {
    Setloader(true);
    refetch().then(() => {
      Setloader(false);
    });
  };


  const {register , handleSubmit, watch, reset} = useForm({
    defaultValues: {
      distributionChannels : [],
      triggerDays : ''
    }
  });

  const selectedChannels = watch('distributionChannels');

  const UpdateSurvey = async (data) => {
    if (!surveyDetails?.id) {
      Swal.fire('Error', 'Survey details not found', 'error');
      return;
    }

    if (!data.distributionChannels || data.distributionChannels.length === 0) {
      Swal.fire('Error', 'Please select at least one distribution channel', 'error');
      return;
    }

    if (!data.triggerDays) {
      Swal.fire('Error', 'Please select a delay', 'error');
      return;
    }

    Setloader(true);

    const payload = {
      templateId: surveyDetails.id,
      campaignName: surveyDetails.templateName,
      description: surveyDetails.description,
      triggerDays: parseInt(data.triggerDays),
      distributionChannels: data.distributionChannels
    };

    try {
      const response = await axios.post(
        `${Constants.url}survey-campaigns/launch-with-auto-targets`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );

      Swal.fire('Success', 'Survey campaign launched successfully', 'success');
      reset();
      setsurveyDetails(null);
      UIkit.modal('#editSurveyModal').hide();
      refetch();
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to launch survey campaign';
      Swal.fire('Error', errorMessage, 'error');
    } finally {
      Setloader(false);
    }
  }

  return (
    <>

      {/* Single Survey Details Edit Modal */}
      <div id="editSurveyModal" uk-modal="" container="#pageId">
        <div className="uk-modal-dialog uk-modal-body" style={{ width: '700px', marginTop: '20px' }}>
          <button className="uk-modal-close-default" type="button" uk-close="" onClick={() => setsurveyDetails(null)}>
            
          </button>

          <div className="survey-campaign-modal">
            {/* Header */}
            <div className="survey-campaign-header">
              <h2>Launch Survey Campaign</h2>
              <p>Configure and launch your survey to selected channels</p>
            </div>

            {/* Survey Details Card */}
            <div className="survey-details-card">
              <div>
                <p className="survey-detail-label">Survey Name</p>
                <p className="survey-detail-value">{surveyDetails?.templateName || '-'}</p>
              </div>
              <div>
                <p className="survey-detail-label">Description</p>
                <p className="survey-detail-value description">{surveyDetails?.description || '-'}</p>
              </div>
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit(UpdateSurvey)}>
              {/* Distribution Channels */}
              <div className="survey-form-group">
                <label className="survey-form-label">
                  Distribution Channels <span className="required">*</span>
                </label>
                <div className="survey-channels-wrapper">
                  <label className="survey-channel-option">
                    <input
                      type="checkbox"
                      value="email"
                      {...register('distributionChannels')}
                      className="uk-checkbox"
                    />
                    <span className="uk-text-bold">Email</span>
                  </label>
                  <label className="survey-channel-option">
                    <input
                      type="checkbox"
                      value="sms"
                      {...register('distributionChannels')}
                      className="uk-checkbox"
                    />
                    <span className="uk-text-bold">SMS</span>
                  </label>
                  {/* <label className="survey-channel-option">
                    <input
                      type="checkbox"
                      value="whatsapp"
                      {...register('distributionChannels')}
                      className="uk-checkbox"
                    />
                    <span className="uk-text-bold">WhatsApp</span>
                  </label> */}
                </div>
              </div>

              {/* Delay */}
              <div className="survey-form-group">
                <label htmlFor="triggerDays" className="survey-form-label">
                  Delay (Days) <span className="required">*</span>
                </label>
                <select
                  id="triggerDays"
                  {...register('triggerDays')}
                  className="survey-select"
                >
                  <option value="">Select Delay</option>
                  <option value="2">2 days</option>
                  <option value="7">1 Week</option>
                  <option value="30">1 Month</option>
                </select>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={loader}
                className="survey-submit-btn"
              >
                {loader ? (
                  <>
                    <div uk-spinner="ratio: 0.6"></div>
                    Launching...
                  </>
                ) : (
                  'Launch Campaign'
                )}
              </button>
            </form>
          </div>
        </div>
      </div>

      {!isLoading && !loader ? (
              <div className="dashboardWrp uk-padding">
                  <div className="uk-container uk-container-expand">
                    <div className="uk-margin ">
                    <div className="uk-flex uk-flex-between ">
                      <div>
                        <h2>Surveys</h2>
                      </div>
                    </div>
                  </div>
                      <div className="uk-grid" uk-grid="">
                          <div className="uk-width-1-1">
                              {/* <SearchHead
                                  searchparam={searchparam}
                                  RefreshFunc={Refresh}
                                  headers={headers}
                                  CsvData={Surveysdata.customers}
                                  Filename={"surveys_data.csv"}
                                  setsearchparam={setsearchparam}
                                  endpoint="surveys"
                                  startDate={startDate}
                                  endDate={endDate}
                                  setStartdate={setStartDate}
                                  setEndDate={setEndDate}
                              /> */}

                              <div className="analyticsTableWrp uk-overflow-auto ">
                                  <table className="uk-table uk-table-striped ">
                                      <thead className="table-header-shadow">
                                          <tr className="uk-text-center">
                                              
                                              <th className="uk-text-center">S.NO</th>
                                              <th className="uk-text-left">Survey Name</th>
                                              {/* <th className="uk-text-center">Survey Description</th> */}
                                              <th className="uk-text-center">Survey Status</th>                                    
                                              {/* white space character */}
                                              <th className="uk-text-center">Action</th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          {Surveys?.map((survey, index) => (
                                              <tr key={index}>
                                                  <>
                                                      <td className="uk-text-center">{(page - 1) * 100 + (index + 1)}</td>
                                                      <td className="uk-text-left">{survey?.templateName || "-"}</td>
                                                      {/* <td className="uk-text-center">{survey.email || "-"}</td> */}
                                                      <td className="uk-text-center">
                                                          <span className={`survey-status-badge ${survey?.isActive ? 'active' : 'inactive'}`}>
                                                              {survey?.isActive ? "Active" : "Inactive"}
                                                          </span>
                                                      </td>                                                     
                                                      <td className="uk-text-center uk-flex uk-flex-middle uk-flex-center">
                                                          <button
                                                              className="uk-button uk-button-secondary survey-add-question-btn"
                                                              title="Edit Survey"
                                                              onClick={() => {
                                                                  setsurveyDetails(survey);
                                                                  UIkit.modal('#editSurveyModal').show();
                                                              }}
                                                          >
                                                              <Edit size={20} />
                                                          </button>
                                                      </td>
                                                  </>
                                              </tr>
                                          ))}
                                      </tbody>
                                  </table>
                                  <div className=" paginationcard uk-card uk-card-default uk-margin-remove-top">
                                      <ReactPaginate
                                          previousLabel={"←"}
                                          nextLabel={"→"}
                                          breakLabel={"..."}
                                          breakClassName={"break-me"}
                                          pageCount={Math.round(Surveysdata.totalRecords / 100)}
                                          marginPagesDisplayed={1}
                                          pageRangeDisplayed={2}
                                          onPageChange={(e) => setPage(e.selected + 1)}
                                          containerClassName={"pagination"}
                                          activeClassName={"active"}
                                          forcePage={page - 1}
                                      />
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
      ) : (
        <SplashScreen />
      )}
    </>
  );
};

export default SurveyList;